module.exports = __webpack_public_path__ + "img/home-boho-sunroom.6f2fbf44.jpg";